export const CUSTOM_EVENTS_LIST = {
  PLAYBACK: 'PLAYBACK',
};

export type events = keyof typeof CUSTOM_EVENTS_LIST;
